import { render, staticRenderFns } from "./extra-list.vue?vue&type=template&id=41fb7f29&"
import script from "./extra-list.vue?vue&type=script&lang=js&"
export * from "./extra-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports